<template>
  <section class="form-autocomplete is-relative m-b-25">
    <ValidationProvider
      ref="validationProvider"
      :rules="rules"
      v-slot="validationProps"
      :name="label || placeholder || 'field'"
      :value="computedValue"
    >
      <float-label :label="computedPlaceholder">
        <AutocompleteView
          ref="autocomplete"
          v-model="computedValue"
          :data="suggestions"
          :placeholder="computedPlaceholder"
          :icon="icon"
          :loading="loading"
          :disabled="disabled"
          :field="displayProperty"
          @input="onInput"
          @select="onSelect"
        />
        <slot name="error" v-bind="validationProps">
          <template v-if="hasValidationErrors(validationProps)">
            <span class="validation-text">
              <IconView icon="close" size="is-small" />
              {{ getErrorFormattedText(validationProps) }}
            </span>
          </template>
        </slot>
      </float-label>
    </ValidationProvider>
  </section>
</template>

<script>
import { debounce } from 'lodash';
import ValidationProvider from '/@/modules/core/form/components/ValidationProvider.vue';
import { FormComputedValueMixin } from '/@/modules/core/form/mixins/FormComputedValueMixin';
import { FormValidationMixin } from '/@/modules/core/form/mixins/FormValidationMixin';
import FloatLabel from '/@/modules/core/form/components/FloatLabel.vue';
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';
import AutocompleteView from '@/modules/core/ui/components/wrappers/AutocompleteView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormAutoComplete',
  emits: ['on-select'],
  slotsDefinition: {
    error: { validationProps: Object }
  },
  mixins: [FormComputedValueMixin, FormValidationMixin],
  components: { IconView, FloatLabel, ValidationProvider, AutocompleteView },
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: { type: String },
    placeholder: { type: String },
    loading: {
      type: Boolean,
      default: false
    },
    suggestionsFn: {
      type: Function,
      required: true
    },
    suggestions: {
      type: Array,
      required: true
    },
    displayProperty: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      debounceQuery: null
    };
  },
  computed: {
    computedPlaceholder() {
      return this.placeholder || this.$t('core.enter-label', { label: this.column?.label || '' });
    }
  },
  methods: {
    onSelect(selection) {
      this.$emit('on-select', selection);
    },
    onInput(newValue) {
      if (newValue !== this.computedValue) {
        this.debounceQuery(newValue);
      }
    },
    hideDropdown() {
      setTimeout(() => {
        this.$refs.autocomplete.isActive = false;
      }, 0);
    }
  },
  created() {
    this.debounceQuery = debounce(this.suggestionsFn, 500);
  }
};
</script>

<style scoped>
:deep(.dropdown-menu) {
  z-index: var(--ce-z-index-20);
}
</style>
